import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Container, Card, Button } from '@/ui';
import { COMPANY_ADVANTAGES, CONTACT_INFO } from '@/constants/navigation';
import { PhoneOutlined, MailOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { colors } from '@/theme/colors';
export const About = () => {
    return (_jsxs(AboutPage, { children: [_jsx(AboutHeroSection, { children: _jsx(Container, { size: "large", children: _jsxs(AboutHeroContent, { children: [_jsxs(AboutHeroText, { children: [_jsx(AboutHeroTitle, { children: "\u041E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 Legarta" }), _jsx(AboutHeroSubtitle, { children: "\u041B\u0438\u0434\u0435\u0440 \u0421\u0438\u0431\u0438\u0440\u0441\u043A\u043E\u0433\u043E \u0440\u0435\u0433\u0438\u043E\u043D\u0430 \u0432 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432" }), _jsx(AboutHeroDescription, { children: "\u041C\u044B \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u0443\u0435\u043C\u0441\u044F \u043D\u0430 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0445 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0438 \u043E\u0442\u0434\u0435\u043B\u043E\u0447\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u0435\u0439 \u0438 \u0447\u0430\u0441\u0442\u043D\u044B\u0445 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432. \u0417\u0430 15+ \u043B\u0435\u0442 \u0440\u0430\u0431\u043E\u0442\u044B \u043C\u044B \u0441\u0442\u0430\u043B\u0438 \u043A\u0440\u0443\u043F\u043D\u0435\u0439\u0448\u0438\u043C \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u043E\u043C \u0432 \u0421\u0438\u0431\u0438\u0440\u0438 \u0441 \u0441\u0435\u0442\u044C\u044E \u0438\u0437 8 \u0441\u043A\u043B\u0430\u0434\u043E\u0432 \u0438 \u0433\u043E\u0434\u043E\u0432\u044B\u043C \u043E\u0431\u043E\u0440\u043E\u0442\u043E\u043C \u0431\u043E\u043B\u0435\u0435 5 \u043C\u043B\u0440\u0434 \u0440\u0443\u0431\u043B\u0435\u0439." })] }), _jsx(AboutHeroVisual, { children: _jsxs(AboutHeroImagePlaceholder, { children: [_jsx(AboutHeroImageText, { children: "\uD83C\uDFE2" }), _jsx(AboutHeroImagePlaceholderText, { children: "Legarta" })] }) })] }) }) }), _jsx(CompanyHistorySection, { children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 Legarta" }), _jsx("p", { children: "\u0411\u043E\u043B\u0435\u0435 15 \u043B\u0435\u0442 \u0443\u0441\u043F\u0435\u0448\u043D\u043E\u0439 \u0440\u0430\u0431\u043E\u0442\u044B \u043D\u0430 \u0440\u044B\u043D\u043A\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432" })] }), _jsxs(Timeline, { children: [_jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2009" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u041E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438" }), _jsx("p", { children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 Legarta \u043A\u0430\u043A \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0434\u043B\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u0435\u0439" })] })] }), _jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2012" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u041F\u0435\u0440\u0432\u044B\u0439 \u0441\u043A\u043B\u0430\u0434\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441" }), _jsx("p", { children: "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043A\u043B\u0430\u0434\u0430 \u0432 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0435 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E 5000 \u043C\u00B2 \u0438 \u043D\u0430\u0447\u0430\u043B\u043E \u043F\u0440\u044F\u043C\u044B\u0445 \u043F\u043E\u0441\u0442\u0430\u0432\u043E\u043A \u0441 \u0432\u0435\u0434\u0443\u0449\u0438\u0445 \u0437\u0430\u0432\u043E\u0434\u043E\u0432 \u0420\u043E\u0441\u0441\u0438\u0438" })] })] }), _jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2015" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0438" }), _jsx("p", { children: "\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u0435 \u0444\u0438\u043B\u0438\u0430\u043B\u043E\u0432 \u0432 \u0411\u0430\u0440\u043D\u0430\u0443\u043B\u0435 \u0438 \u0422\u043E\u043C\u0441\u043A\u0435, \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0430\u0441\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u0430 \u0434\u043E 50,000 \u043D\u0430\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0438\u0439" })] })] }), _jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2018" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u0421\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440" }), _jsx("p", { children: "\u041F\u0435\u0440\u0435\u0435\u0437\u0434 \u0432 \u043D\u043E\u0432\u044B\u0439 \u0441\u043A\u043B\u0430\u0434\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E 25,000 \u043C\u00B2 \u0441 \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u043C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u043C\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0430\u043C\u0438" })] })] }), _jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2021" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u0426\u0438\u0444\u0440\u043E\u0432\u0438\u0437\u0430\u0446\u0438\u044F \u0438 \u043E\u043D\u043B\u0430\u0439\u043D-\u043F\u0440\u043E\u0434\u0430\u0436\u0438" }), _jsx("p", { children: "\u0417\u0430\u043F\u0443\u0441\u043A \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442-\u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430, \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0438\u0435 CRM-\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0438 \u0440\u0430\u0437\u0432\u0438\u0442\u0438\u0435 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043A\u043E\u043C\u043C\u0435\u0440\u0446\u0438\u0438" })] })] }), _jsxs(TimelineItem, { children: [_jsx(TimelineYear, { children: "2024" }), _jsxs(TimelineContent, { children: [_jsx("h3", { children: "\u041B\u0438\u0434\u0435\u0440 \u0421\u0438\u0431\u0438\u0440\u0441\u043A\u043E\u0433\u043E \u0440\u0435\u0433\u0438\u043E\u043D\u0430" }), _jsx("p", { children: "\u0421\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u0440\u0443\u043F\u043D\u0435\u0439\u0448\u0438\u043C \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u043E\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432 \u0432 \u0421\u0438\u0431\u0438\u0440\u0438 \u0441 \u0441\u0435\u0442\u044C\u044E \u0438\u0437 8 \u0441\u043A\u043B\u0430\u0434\u043E\u0432 \u0438 \u0433\u043E\u0434\u043E\u0432\u044B\u043C \u043E\u0431\u043E\u0440\u043E\u0442\u043E\u043C \u0431\u043E\u043B\u0435\u0435 5 \u043C\u043B\u0440\u0434 \u0440\u0443\u0431\u043B\u0435\u0439" })] })] })] })] }) }), _jsx(AboutAdvantagesSection, { id: "advantages", children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u041D\u0430\u0448\u0438 \u043F\u0440\u0435\u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u0430" }), _jsx("p", { children: "\u041F\u043E\u0447\u0435\u043C\u0443 \u043A\u043B\u0438\u0435\u043D\u0442\u044B \u0432\u044B\u0431\u0438\u0440\u0430\u044E\u0442 \u0438\u043C\u0435\u043D\u043D\u043E \u043D\u0430\u0441" })] }), _jsx(AdvantagesGrid, { children: COMPANY_ADVANTAGES.map((advantage) => (_jsx(AdvantageCard, { variant: "elevated", children: _jsxs(AdvantageContent, { children: [_jsx(AdvantageIcon, { children: advantage.icon }), _jsx(AdvantageTitle, { children: advantage.title }), _jsx(AdvantageDescription, { children: advantage.description })] }) }, advantage.id))) })] }) }), _jsx(WarehouseSection, { id: "warehouse", children: _jsx(Container, { size: "large", children: _jsxs(WarehouseContent, { children: [_jsxs(WarehouseInfo, { children: [_jsx("h2", { children: "\u0421\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440" }), _jsx("p", { children: "\u041D\u0430\u0448 \u0441\u043A\u043B\u0430\u0434\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0432 \u041D\u043E\u0432\u043E\u0441\u0438\u0431\u0438\u0440\u0441\u043A\u0435 - \u044D\u0442\u043E \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0439 \u043B\u043E\u0433\u0438\u0441\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0446\u0435\u043D\u0442\u0440 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E \u0431\u043E\u043B\u0435\u0435 25,000 \u043C\u00B2, \u043E\u0441\u043D\u0430\u0449\u0435\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u044B\u043C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0434\u043B\u044F \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F, \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u0438 \u0438 \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432." }), _jsxs(WarehouseFeatures, { children: [_jsxs(WarehouseFeature, { children: [_jsx(FeatureIcon, { children: "\uD83D\uDCE6" }), _jsxs(WarehouseFeatureContent, { children: [_jsx("h4", { children: "\u041F\u043B\u043E\u0449\u0430\u0434\u044C" }), _jsx("p", { children: "\u0411\u043E\u043B\u0435\u0435 25,000 \u043C\u00B2 \u0441\u043A\u043B\u0430\u0434\u0441\u043A\u0438\u0445 \u043F\u043B\u043E\u0449\u0430\u0434\u0435\u0439" })] })] }), _jsxs(WarehouseFeature, { children: [_jsx(FeatureIcon, { children: "\uD83D\uDE9A" }), _jsxs(WarehouseFeatureContent, { children: [_jsx("h4", { children: "\u041B\u043E\u0433\u0438\u0441\u0442\u0438\u043A\u0430" }), _jsx("p", { children: "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0430\u0432\u0442\u043E\u043F\u0430\u0440\u043A \u0434\u043B\u044F \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438" })] })] }), _jsxs(WarehouseFeature, { children: [_jsx(FeatureIcon, { children: "\uD83D\uDD12" }), _jsxs(WarehouseFeatureContent, { children: [_jsx("h4", { children: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C" }), _jsx("p", { children: "\u041A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u0430\u044F \u043E\u0445\u0440\u0430\u043D\u0430 \u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F" })] })] }), _jsxs(WarehouseFeature, { children: [_jsx(FeatureIcon, { children: "\uD83D\uDE80" }), _jsxs(WarehouseFeatureContent, { children: [_jsx("h4", { children: "\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u044C" }), _jsx("p", { children: "\u0411\u044B\u0441\u0442\u0440\u0430\u044F \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0430 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 2-4 \u0447\u0430\u0441\u043E\u0432" })] })] })] })] }), _jsx(WarehouseVisual, { children: _jsxs(WarehouseImagePlaceholder, { children: [_jsx(WarehouseImageText, { children: "\uD83C\uDFED" }), _jsx(WarehouseImagePlaceholderText, { children: "\u0421\u043A\u043B\u0430\u0434\u0441\u043A\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441" })] }) })] }) }) }), _jsx(PartnersSection, { id: "partners", children: _jsxs(Container, { size: "large", children: [_jsxs(SectionHeader, { children: [_jsx("h2", { children: "\u041D\u0430\u0448\u0438 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u044B" }), _jsx("p", { children: "\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u043C \u0441 \u0432\u0435\u0434\u0443\u0449\u0438\u043C\u0438 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u043E\u0432" })] }), _jsxs(PartnersGrid, { children: [_jsx(PartnerCard, { variant: "outlined", children: _jsxs(PartnerContent, { children: [_jsx(PartnerIcon, { children: "\uD83C\uDFED" }), _jsx(PartnerTitle, { children: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438" }), _jsx(PartnerDescription, { children: "\u041F\u0440\u044F\u043C\u044B\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0441 \u0437\u0430\u0432\u043E\u0434\u043E\u0432-\u0438\u0437\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u0435\u043B\u0435\u0439" })] }) }), _jsx(PartnerCard, { variant: "outlined", children: _jsxs(PartnerContent, { children: [_jsx(PartnerIcon, { children: "\uD83D\uDEA7" }), _jsx(PartnerTitle, { children: "\u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438" }), _jsx(PartnerDescription, { children: "\u0414\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0435 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441 \u043A\u0440\u0443\u043F\u043D\u044B\u043C\u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430\u043C\u0438" })] }) }), _jsx(PartnerCard, { variant: "outlined", children: _jsxs(PartnerContent, { children: [_jsx(PartnerIcon, { children: "\uD83C\uDFEA" }), _jsx(PartnerTitle, { children: "\u0420\u043E\u0437\u043D\u0438\u0447\u043D\u044B\u0435 \u0441\u0435\u0442\u0438" }), _jsx(PartnerDescription, { children: "\u041F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432" })] }) }), _jsx(PartnerCard, { variant: "outlined", children: _jsxs(PartnerContent, { children: [_jsx(PartnerIcon, { children: "\uD83D\uDD28" }), _jsx(PartnerTitle, { children: "\u0427\u0430\u0441\u0442\u043D\u044B\u0435 \u043C\u0430\u0441\u0442\u0435\u0440\u0430" }), _jsx(PartnerDescription, { children: "\u0418\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u0434\u043B\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u043E\u0432" })] }) })] })] }) }), _jsx(ContactCtaSection, { children: _jsx(Container, { size: "large", children: _jsx(ContactCtaContent, { children: _jsxs(ContactCtaInfo, { children: [_jsx("h2", { children: "\u0413\u043E\u0442\u043E\u0432\u044B \u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0443?" }), _jsx("p", { children: "\u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u043D\u0430\u043C\u0438 \u0434\u043B\u044F \u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043F\u043E\u0441\u0442\u0430\u0432\u043E\u043A \u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F" }), _jsxs(ContactCtaDetails, { children: [_jsxs(ContactCtaDetail, { children: [_jsx(PhoneOutlined, { style: { color: colors.primary, fontSize: 20 } }), _jsx("span", { children: CONTACT_INFO.phone })] }), _jsxs(ContactCtaDetail, { children: [_jsx(MailOutlined, { style: { color: colors.primary, fontSize: 20 } }), _jsx("span", { children: CONTACT_INFO.email })] }), _jsxs(ContactCtaDetail, { children: [_jsx(EnvironmentOutlined, { style: { color: colors.primary, fontSize: 20 } }), _jsx("span", { children: CONTACT_INFO.address })] }), _jsxs(ContactCtaDetail, { children: [_jsx("span", { style: { color: colors.primary, fontSize: 20 }, children: "\u23F0" }), _jsx("span", { children: CONTACT_INFO.workingHours })] })] }), _jsxs(CompanyStats, { children: [_jsxs(CompanyStat, { children: [_jsx(StatIcon, { children: "\uD83C\uDFD7\uFE0F" }), _jsxs(StatContent, { children: [_jsx(StatNumber, { children: CONTACT_INFO.founded }), _jsx(StatLabel, { children: "\u0413\u043E\u0434 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u044F" })] })] }), _jsxs(CompanyStat, { children: [_jsx(StatIcon, { children: "\uD83D\uDC77" }), _jsxs(StatContent, { children: [_jsx(StatNumber, { children: CONTACT_INFO.employees }), _jsx(StatLabel, { children: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432" })] })] }), _jsxs(CompanyStat, { children: [_jsx(StatIcon, { children: "\uD83D\uDCBC" }), _jsxs(StatContent, { children: [_jsx(StatNumber, { children: CONTACT_INFO.turnover }), _jsx(StatLabel, { children: "\u0413\u043E\u0434\u043E\u0432\u043E\u0439 \u043E\u0431\u043E\u0440\u043E\u0442" })] })] }), _jsxs(CompanyStat, { children: [_jsx(StatIcon, { children: "\uD83C\uDF0D" }), _jsxs(StatContent, { children: [_jsx(StatNumber, { children: CONTACT_INFO.website }), _jsx(StatLabel, { children: "\u0412\u0435\u0431-\u0441\u0430\u0439\u0442" })] })] })] }), _jsxs(ContactCtaActions, { children: [_jsx(Button, { variant: "primary", size: "large", children: "\u0417\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0437\u0432\u043E\u043D\u043E\u043A" }), _jsx(Button, { variant: "outline", size: "large", children: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E" })] })] }) }) }) })] }));
};
const AboutPage = styled.div `
  min-height: 100vh;
`;
const AboutHeroSection = styled.section `
  background: ${colors.gradientAbout};
  background-size: 400% 400%;
  animation: gradientShift 8s ease-in-out infinite;
  padding: 120px 0 80px;
  color: ${colors.textWhite};
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.gradientAboutRadial};
    background-size: 200% 200%;
    animation: radialShift 12s ease-in-out infinite;
    opacity: 0.3;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${colors.gradientAboutConic};
    background-size: 300% 300%;
    animation: conicShift 20s linear infinite;
    opacity: 0.1;
  }

  @media (max-width: 768px) {
    padding: 80px 0 60px;
  }

  @media (max-width: 480px) {
    padding: 60px 0 40px;
  }

  @keyframes gradientShift {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
  }

  @keyframes radialShift {
    0%, 100% { background-position: 0% 0%; }
    50% { background-position: 100% 100%; }
  }

  @keyframes conicShift {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
const AboutHeroContent = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
`;
const AboutHeroText = styled.div ``;
const AboutHeroTitle = styled.h1 `
  font-size: 48px;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.2;

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;
const AboutHeroSubtitle = styled.p `
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 24px 0;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 18px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
const AboutHeroDescription = styled.p `
  font-size: 18px;
  line-height: 1.6;
  margin: 0;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 15px;
  }
`;
const AboutHeroVisual = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const AboutHeroImagePlaceholder = styled.div `
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 400px;
  width: 100%;
`;
const AboutHeroImageText = styled.span `
  font-size: 80px;
  display: block;
  margin-bottom: 20px;
`;
const AboutHeroImagePlaceholderText = styled.p `
  font-size: 18px;
  margin: 0;
  font-weight: 500;
`;
const CompanyHistorySection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  p {
    font-size: 18px;
    color: ${colors.textSecondary};
    margin: 0;
    max-width: 600px;
    margin: 0 auto;
  }
`;
const Timeline = styled.div `
  max-width: 800px;
  margin: 0 auto;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background: ${colors.borderLight};
    transform: translateX(-50%);
  }

  @media (max-width: 1024px) {
    &::before {
      left: 30px;
    }
  }
`;
const TimelineItem = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  position: relative;

  &:nth-child(odd) {
    flex-direction: row;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;
  }

  @media (max-width: 1024px) {
    flex-direction: row !important;
  }
`;
const TimelineYear = styled.div `
  background: ${colors.primary};
  color: ${colors.textWhite};
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 600;
  font-size: 18px;
  min-width: 100px;
  text-align: center;
  position: relative;
  z-index: 2;

  @media (max-width: 1024px) {
    margin-right: 20px;
  }

  @media (max-width: 480px) {
    min-width: 80px;
    font-size: 16px;
    padding: 8px 16px;
  }
`;
const TimelineContent = styled.div `
  flex: 1;
  padding: 0 40px;
  text-align: center;

  @media (max-width: 1024px) {
    text-align: left;
    padding: 0 0 0 20px;
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
    color: ${colors.textPrimary};
    margin: 0 0 12px 0;
  }

  p {
    color: ${colors.textSecondary};
    line-height: 1.5;
    margin: 0;
  }
`;
const AboutAdvantagesSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundSecondary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const AdvantagesGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  align-items: stretch;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const AdvantageCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const AdvantageContent = styled.div `
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
`;
const AdvantageIcon = styled.div `
  font-size: 48px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const AdvantageTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
  text-align: center;
  width: 100%;
`;
const AdvantageDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0;
  text-align: center;
  width: 100%;
`;
const WarehouseSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const WarehouseContent = styled.div `
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;

  @media (max-width: 1024px) {
    gap: 40px;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 40px;
    text-align: center;
  }
`;
const WarehouseInfo = styled.div `
  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 24px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  > p {
    font-size: 18px;
    color: ${colors.textSecondary};
    line-height: 1.6;
    margin: 0 0 32px 0;
  }
`;
const WarehouseFeatures = styled.div `
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const WarehouseFeature = styled.div `
  display: flex;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;
const FeatureIcon = styled.span `
  font-size: 24px;
  margin-top: 2px;
`;
const WarehouseFeatureContent = styled.div `
  h4 {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.textPrimary};
    margin: 0 0 4px 0;
  }

  p {
    color: ${colors.textSecondary};
    margin: 0;
  }
`;
const WarehouseVisual = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
`;
const WarehouseImagePlaceholder = styled.div `
  background: ${colors.backgroundSecondary};
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  border: 2px dashed ${colors.borderMedium};
  max-width: 400px;
  width: 100%;
`;
const WarehouseImageText = styled.span `
  font-size: 80px;
  display: block;
  margin-bottom: 20px;
`;
const WarehouseImagePlaceholderText = styled.p `
  font-size: 18px;
  color: ${colors.textSecondary};
  margin: 0;
  font-weight: 500;
`;
const PartnersSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundSecondary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const PartnersGrid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const PartnerCard = styled(Card) `
  text-align: center;
  height: 100%;
`;
const PartnerContent = styled.div `
  padding: 20px;
`;
const PartnerIcon = styled.div `
  font-size: 48px;
  margin-bottom: 20px;
`;
const PartnerTitle = styled.h3 `
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 12px 0;
`;
const PartnerDescription = styled.p `
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin: 0;
`;
const ContactCtaSection = styled.section `
  padding: 80px 0;
  background: ${colors.backgroundPrimary};

  @media (max-width: 768px) {
    padding: 60px 0;
  }
`;
const ContactCtaContent = styled.div `
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
`;
const ContactCtaInfo = styled.div `
  h2 {
    font-size: 36px;
    font-weight: 700;
    color: ${colors.textPrimary};
    margin: 0 0 16px 0;

    @media (max-width: 1024px) {
      font-size: 32px;
    }

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  > p {
    font-size: 18px;
    color: ${colors.textSecondary};
    line-height: 1.6;
    margin: 0 0 32px 0;
  }
`;
const ContactCtaDetails = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
`;
const ContactCtaDetail = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: ${colors.textSecondary};
`;
const ContactCtaIcon = styled.span `
  color: ${colors.primary};
  font-size: 20px;
`;
const ContactCtaActions = styled.div `
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;
const CompanyStats = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin: 32px 0;
  padding: 32px;
  background: ${colors.backgroundLight};
  border-radius: 12px;
  text-align: center;
`;
const CompanyStat = styled.div `
  display: flex;
  align-items: center;
  gap: 16px;
  text-align: center;
  justify-content: center;
`;
const StatIcon = styled.span `
  color: ${colors.primary};
  font-size: 32px;
`;
const StatContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StatNumber = styled.span `
  font-size: 24px;
  font-weight: 700;
  color: ${colors.textPrimary};
  margin-bottom: 4px;
`;
const StatLabel = styled.span `
  font-size: 14px;
  color: ${colors.textSecondary};
  text-align: center;
`;
